<template>
  <div
    v-if="show && member"
    class="customer-popup-overlay"
    @click.self="$emit('close')"
  >
    <div class="customer-popup-content">
      <!-- Header -->
      <div class="customer-popup-header">
        <div>
          <h3 class="customer-popup-title">{{ member.name }}</h3>
          <p class="customer-popup-subtitle">Team Member Details</p>
        </div>
        <button @click="$emit('close')" class="customer-popup-close" aria-label="Close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      
      <!-- Body -->
      <div class="customer-popup-body">
        <!-- Team Member Information -->
        <div class="customer-popup-section">
          <div v-if="member.email" class="customer-popup-data-row">
            <div class="customer-popup-label">Email:</div>
            <div class="customer-popup-value">
              <a :href="`mailto:${member.email}`" class="customer-popup-link">{{ member.email }}</a>
            </div>
          </div>
          
          <div class="customer-popup-data-row">
            <div class="customer-popup-label">Address:</div>
            <div class="customer-popup-value">{{ member.address_line_1 || 'N/A' }}</div>
          </div>
          
          <div class="customer-popup-data-row">
            <div class="customer-popup-label">City:</div>
            <div class="customer-popup-value">{{ member.city || 'N/A' }}</div>
          </div>
          
          <div class="customer-popup-data-row">
            <div class="customer-popup-label">State:</div>
            <div class="customer-popup-value">{{ member.state || 'N/A' }}</div>
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="customer-popup-footer">
        <button @click="$emit('close')" class="customer-popup-button">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamPopup',
  
  props: {
    member: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  
  mounted() {
    document.addEventListener('keydown', this.handleEscKey);
  },
  
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKey);
  },
  
  methods: {
    handleEscKey(event) {
      if (event.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    }
  }
};
</script>
